
import { RoadmapTemplate } from '@/types/roadmap';
import { handleError } from './utils';
import { updateTemplateRecord, updateSteps, updateSidebar } from './updateOperations';

export async function updateTemplate(template: RoadmapTemplate): Promise<void> {
  try {
    console.log('updateTemplate: Starting update for template:', template.id);
    console.log('updateTemplate: embedCode value:', template.embedCode);
    console.log('updateTemplate: lessonHtml value:', template.lessonHtml);
    
    // Update the main template record
    await updateTemplateRecord(template);

    // Update steps and their related data
    await updateSteps(template.id, template.steps);

    // Update sidebar
    await updateSidebar(template.id, template.sidebar);
    
    console.log('updateTemplate: Template updated successfully');
  } catch (error) {
    console.error('updateTemplate: Error updating template:', error);
    handleError(error, 'Error updating template');
  }
}
